import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporters(customer_id) {
    return RequesterV1.get(
      `customer/reporting/process/list_agro_exporters/${customer_id}`
    );
  }
};
